import { useEffect, useCallback } from 'react';

type Params = {
  callback: Function;
};

export function useDOMObserver({ callback }: Params) {
  const handleEvent = useCallback(mutations => callback(mutations), [callback]);

  useEffect(() => {
    const MutationObserver = window.MutationObserver;
    const body = document.body;
    let obs;
    if (MutationObserver) {
      obs = new MutationObserver(handleEvent);
      obs.observe(body, { childList: true, subtree: true });
    } else if (window.addEventListener) {
      body.addEventListener('DOMNodeInserted', handleEvent, false);
      body.addEventListener('DOMNodeRemoved', handleEvent, false);
    }

    return () => {
      if (obs) obs.disconnect();
      body.removeEventListener('DOMNodeInserted', handleEvent, false);
      body.removeEventListener('DOMNodeRemoved', handleEvent, false);
    };
  }, []);
}
